<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-10 11:20:25
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 14:16:24
 * @Description: 月报列表
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\monthlyReportList.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right">
          <el-button class="bottom_all_two" @click="goBack">返 回</el-button>
        </div>
        <div class="card" style="margin-top: 30px">
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <el-table-column align="center" label="工程编号" prop="engineeringCode"></el-table-column>
              <el-table-column align="center" label="工程名称" min-width="230" prop="engineeringName"></el-table-column>
              <el-table-column align="center" label="上次截止时间" prop="lastDueTime"></el-table-column>
              <el-table-column align="center" label="本次截止时间" prop="currentDueTime"></el-table-column>
              <el-table-column align="center" label="供应状态是否确认" prop>
                <template slot-scope="scope">
                  <el-link v-if="scope.row.supplyPhaseId || scope.row.supplyPhaseId == '0'" type="success" :underline="false" @click="openSupplyPhase(scope.row, true)">是</el-link>
                  <el-link v-else type="danger" :underline="false" @click="openSupplyPhase(scope.row, false)">否</el-link>
                </template>
              </el-table-column>
              <el-table-column align="center" label="确认状态" prop>
                <template slot-scope="scope">
                  <span>{{ mouthReportStatusList | fromatTable(scope.row.sureStatus, "name", "id") }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.sureStatus != 1" type="success" :disabled="!scope.row.supplyPhaseId && scope.row.supplyPhaseId != '0'" :underline="false" @click="toConfirm(scope.row, scope.$index)">{{
                    scope.row.sureStatus == 0 ? "去确认" : "更新"
                  }}</el-link>
                  <el-link v-else type="success" :underline="false" @click="toConfirm(scope.row)">查看</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
      <!-- 工程供应状态确认 -->
      <el-dialog v-dialogDrag :visible.sync="supplyPhaseDialog" width="780px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">工程供应状态确认</span>
        <div>
          <el-form ref="supplyPhaseForm" :inline="true" :rules="rules" :model="supplyPhaseForm" label-width="200px" label-position="right">
            <el-form-item prop="settlementCycle" label-width="100px" label="结算周期：" style="float: none">
              <el-input v-model="supplyPhaseForm.settlementCycle" :disabled="true" type="Number" oninput="if(value>31||value<1)value=31" style="width: 200px" @focus.native="tooltipStatus = true" @blur.native="tooltipStatus = false">
                <template slot="prepend">每月</template>
                <template slot="append">号</template>
              </el-input>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content">填写[1]判断为自然月<br />填写[2-31]判断为指定日期</div>
                <i class="el-icon-warning-outline delete-icon"></i>
              </el-tooltip>
            </el-form-item>
            <div>
              <el-form-item prop="supplyPhaseId" label="供应阶段：" label-width="100px">
                <el-input v-model="supplyPhaseForm.supplyPhase" disabled  style="width: 200px" @blur="setCollectMoneyMouth">
                </el-input>
                <!-- <el-select v-model="supplyPhaseForm.supplyPhaseId" :disabled="true" style="width: 200px">
                  <el-option v-for="(item, k) in engineeringPhaseList" :key="k" :label="item.supplyPhase" :value="item.id" @click.native="changeSupplyPhase(item)"></el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item prop="startTime" label="供应阶段开始时间：">
                <el-date-picker v-model="supplyPhaseForm.startTime" :disabled="true" style="width: 200px" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
              </el-form-item>
            </div>
            <div>
              <el-form-item prop="accountPeriod" label="账  期：" label-width="100px">
                <el-input v-model="supplyPhaseForm.accountPeriod" type="Number" style="width: 200px" @blur="setCollectMoneyMouth">
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="item" label="应收比例：">
                <el-input v-model="supplyPhaseForm.item" class="FZTcenter" style="width: 200px" type="Number" :min="1" :max="100" :controls="false">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="应收月份：" label-width="100px">
              {{ supplyPhaseForm.collectMoneyMouth }}
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="supplyPhaseDialog = false">取 消</el-button>
          <el-button class="bottom_all" style="margin-left: 24px" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPageByMonth, queryPhaseNow, sureSupplyStatus } from "@/api/internetSales/monthlyReportUnitRecord.js";
import { controlqueryPhase } from "@/api/smart/schedul/c.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {},
  mixins: [mixin],
  data() {
    return {
      UserInfo: "",
      params: {},
      tableParamType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPageByMonth,
      pagesType: 0,
      mouthReportStatusList: [
        { name: "待确认", id: 0 },
        { name: "已确认", id: 1 },
        { name: "待更新(月报)", id: 2 },
        { name: "待更新(期数)", id: 3 },
      ],
      supplyPhaseDialog: false,
      tooltipStatus: false,
      onlyRead: false,
      engineeringPhaseList: [],
      supplyPhaseForm: {},
      rules: {
        settlementCycle: [{ required: true, message: "请输入结算周期", trigger: "blur" }],
        accountPeriod: [{ required: true, message: "请输入账期", trigger: "blur" }],
        item: [{ required: true, message: "请输入应收比例", trigger: "blur" }],
        supplyPhaseId: [{ required: true, message: "请选择供应阶段", trigger: "change" }],
        startTime: [{ required: true, message: "请选择开始时间", trigger: "change" }],
      },
      low: "",
    };
  },
  async created() {
    this.params = JSON.parse(this.$route.query.row);
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam, engineeringId: this.params.engineeringId, dataType: 1 };
    this.gettableData();
  },

  methods: {
    changeSupplyPhase(item) {
      this.supplyPhaseForm.supplyPhase = item.supplyPhase;
      this.supplyPhaseForm.accountPeriod = item.accountPeriod || "";
      this.supplyPhaseForm.item = item.item || "";
    },
    setCollectMoneyMouth() {
      let num = Math.floor(Number((this.supplyPhaseForm.accountPeriod || 0) / 30));
      console.log(num);
      if (num > 0) {
        num = num - 1;
      }
      var date = new Date(this.low.currentDueTime);
      console.log(date.getMonth());
      console.log(date.getMonth() + num);
      date.setDate(1);
      date.setMonth(date.getMonth() + num);
      this.supplyPhaseForm.collectMoneyMouth = date.Format("yyyy-MM");
    },
    submit() {
      this.$refs.supplyPhaseForm.validate(valid => {
        if (valid) {
          sureSupplyStatus(this.supplyPhaseForm).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功");
              this.gettableData();
              this.supplyPhaseDialog = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    openSupplyPhase(row, onlyRead) {
      this.onlyRead = onlyRead;
      this.low = row;
      controlqueryPhase({
        engineeringId: row.engineeringId,
        // type: 2,
      }).then(res => {
        res.data.push({ id: "1", supplyPhase: "无" });
        this.engineeringPhaseList = res.data;
        if (onlyRead) {
          this.supplyPhaseForm = {
            id: row.id,
            settlementCycle: row.settlementCycle,
            supplyPhaseId: row.supplyPhaseId,
            supplyPhase: row.supplyPhase,
            accountPeriod: row.accountPeriod,
            item: row.item,
            startTime: row.startTime,
            collectMoneyMouth: row.collectMoneyMouth,
          };
          this.setCollectMoneyMouth();
          this.supplyPhaseDialog = true;
        } else {
          queryPhaseNow({ engineeringId: row.engineeringId }).then(res => {
            if (res.code == 1001) {
              this.supplyPhaseForm = {
                id: row.id,
                settlementCycle: res.data.settlementCycle,
                supplyPhaseId: res.data.supplyPhaseId,
                supplyPhase: res.data.supplyPhase,
                accountPeriod: res.data.accountPeriod,
                item: res.data.item,
                startTime: res.data.startTime,
                collectMoneyMouth: res.data.collectMoneyMouth,
              };
              this.setCollectMoneyMouth();
              this.supplyPhaseDialog = true;
            }
          });
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    //   去确认
    toConfirm(row, index) {
      if (row.sureRecentlyPerid == 1) {
        this.$message.warning("请按照时间先后顺序进行确认！");
        return;
      }
      if (index || index == 0) {
        let status = false; //判断是否可以去确认
        if (index == this.tableData.length - 1) {
          status = true;
        } else {
          status = this.tableData[index + 1].sureStatus != 1 ? false : true; //为了调试 true 和false 位置反
        }
        this.tableData.forEach((item, index2) => {
          if (index2 > index && item.sureStatus != 1) {
            status = false;
          }
        });
        if (!status) {
          this.$message.warning("请按照时间先后顺序进行确认！");
          return;
        }
      }
      this.$router.push({ name: "mouthReportRecordList", query: { row: JSON.stringify(row), parentRow: JSON.stringify(this.params) } });
    },
    goBack() {
      this.$router.push({ name: "monthlyReportUnitRecord" });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.styleA {
  overflow: auto;
  max-height: calc(85vh - 266px);
  padding-right: 10px;
}
.styleB {
  overflow: auto;
  max-height: calc(85vh - 366px);
  padding-right: 10px;
}
.saledialoginfo {
  padding: 20px 20px 0 0px;
  max-height: calc(85vh - 220px);
}
.el-input,
.el-select {
  width: 240px;
}
.top_link {
  color: #008000;
}
.top_link:hover {
  cursor: pointer;
  opacity: 0.7;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  width: 378px;
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  margin: 20px 20px 0 20px;
  > div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }
    .active {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }
    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}
.el-input,
.el-select {
  width: 227px;
}
.dialoginfo {
  padding: 0;
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
</style>
  